export default __webpack_public_path__ + "static/media/globe.3b2960a9.svg";